export const RESERVED_CLIENT_CHANNEL_SLUGS = [
  "admin",
  "api",
  "assets",
  "auth",
  "codeer",
  "login",
  "logout",
  "oauth",
  "static",
  "widget",
] as const

export type ClientChannelSlugIssue = "reserved" | "taken"

const reservedClientChannelSlugSet = new Set<string>(
  RESERVED_CLIENT_CHANNEL_SLUGS
)

export function normalizeClientChannelSlug(slug: string): string {
  return slug.trim().toLowerCase()
}

export function isReservedClientChannelSlug(slug: string): boolean {
  return reservedClientChannelSlugSet.has(normalizeClientChannelSlug(slug))
}

export function getClientChannelSlugIssue(
  slug: string,
  message?: string | null
): ClientChannelSlugIssue | null {
  if (isReservedClientChannelSlug(slug)) {
    return "reserved"
  }

  const normalizedMessage = message?.toLowerCase() ?? ""
  if (normalizedMessage.includes("reserved for system use")) {
    return "reserved"
  }

  if (
    normalizedMessage.includes("slug already exists") ||
    normalizedMessage.includes("already taken")
  ) {
    return "taken"
  }

  return null
}
